import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Search } from "lucide-react";

export default function LookupPage() {
  const [ref, setRef] = useState("");
  const [phone, setPhone] = useState("");
  const [res, setRes] = useState(null);
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/appointments/lookup", { reference: ref, phone });
      setRes(data);
    } catch (err) {
      setRes(null);
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  }

  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-xl mx-auto">
      <div className="text-xs uppercase tracking-[0.2em] font-semibold text-emerald-700 mb-2">Status Lookup</div>
      <h1 className="text-3xl font-display font-bold text-slate-900">Check your appointment</h1>
      <p className="text-slate-600 mt-2">Enter the booking reference you received and your phone number.</p>
      <form onSubmit={submit} className="mt-7 bg-white border border-slate-200 rounded-2xl p-6 space-y-4">
        <label className="block">
          <div className="text-xs text-slate-600 font-medium mb-1.5">Booking Reference</div>
          <input value={ref} onChange={(e) => setRef(e.target.value)} className="input" placeholder="DP-1234567" data-testid="lookup-reference-input" />
        </label>
        <label className="block">
          <div className="text-xs text-slate-600 font-medium mb-1.5">Mobile Number</div>
          <input value={phone} onChange={(e) => setPhone(e.target.value)} className="input" placeholder="+91 98765 43210" data-testid="lookup-phone-input" />
        </label>
        <button
          type="submit" disabled={loading}
          className="w-full inline-flex items-center justify-center gap-2 bg-[#0F4C81] hover:bg-[#0A365C] text-white font-semibold rounded-xl px-5 py-3 disabled:opacity-50"
          data-testid="lookup-submit-button"
        >
          <Search size={16} /> {loading ? "Looking up..." : "Check status"}
        </button>
      </form>
      {res && (
        <div className="mt-6 bg-white border border-slate-200 rounded-2xl p-6" data-testid="lookup-result">
          <div className="font-mono text-xl font-bold text-[#0F4C81]">{res.reference}</div>
          <div className="mt-3 text-sm space-y-1">
            <div><span className="text-slate-500">Patient:</span> {res.patient_name}</div>
            <div><span className="text-slate-500">Date:</span> {res.date}</div>
            <div><span className="text-slate-500">Time:</span> {res.start_time} – {res.end_time}</div>
            <div><span className="text-slate-500">Type:</span> {res.consultation_type}</div>
            <div><span className="text-slate-500">Status:</span>{" "}
              <span data-testid="lookup-status-badge" className={`inline-block px-2 py-0.5 rounded-full text-xs font-semibold capitalize ${({pending:"bg-amber-100 text-amber-800",confirmed:"bg-emerald-100 text-emerald-800",rescheduled:"bg-sky-100 text-sky-800",cancelled:"bg-rose-100 text-rose-800",completed:"bg-indigo-100 text-indigo-800",no_show:"bg-slate-200 text-slate-700"})[res.status]||"bg-slate-100"}`}>{res.status.replace("_", " ")}</span>
            </div>
          </div>
        </div>
      )}
      <style>{`.input{width:100%;padding:.65rem .9rem;border:1px solid #CBD5E1;border-radius:.75rem;background:#fff;color:#0F172A;font-size:.95rem;}
      .input:focus{outline:none;border-color:#0D9488;box-shadow:0 0 0 3px rgb(13 148 136 / 0.15)}`}</style>
    </section>
  );
}
